import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet-async";
import { NavigationProvider } from "./NavigationProvider";
import NavigationLayout from "./NavigationLayout";

export default function NavigationPage() {
  const { t } = useTranslation();

  return (
    <NavigationProvider>
      <Helmet>
        <title>Assist - {t("navigation:title")}</title>
      </Helmet>
      <NavigationLayout />
    </NavigationProvider>
  );
}
